import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaHome } from 'react-icons/fa';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>HeroPixelLab</h3>
            <p className="about-text">Din eksklusive destinasjon for premium online dataspill. Vi tilbyr det beste innen spillverdenen med kvalitet og innovasjon.</p>
          </div>
          <div className="footer-section">
            <h3>Navigasjon</h3>
            <ul className="footer-links">
              <li><Link to="/">Hjem</Link></li>
              <li><Link to="/about">Om Oss</Link></li>
              <li><Link to="/contact">Kontakt</Link></li>
              <li><Link to="/cart">Handlekurv</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Info</h3>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Personvernpolitikk</Link></li>
              <li><Link to="/terms-conditions">Vilkår og betingelser</Link></li>
              <li><Link to="/refund-policy">Returpolicy</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Kontaktinformasjon</h3>
            <ul className="footer-links">
              <li><FaHome /> Kirkegata 15, 4611 Kristiansand, Norge</li>
              <li><FaPhone /> +4738172040</li>
              <li><FaEnvelope /> heropixellab@hotmail.com</li>
            <li><a href="https://wa.me/4738172040">WhatsApp</a></li>
            <li><a href="https://viber.me/4738172040">Viber</a></li>
            <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://www.instagram.com/accounts/login/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                           
              <li>Registreringsnummer: 70100414</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {currentYear} HeroPixelLab. Alle rettigheter reservert.</p>
          <p>Org.nr: 70100414</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;